export default "__VITE_ASSET__By732DGv__"